import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
        main: '#f4efea',
    },
    secondary: {
        main: '#6fc2ff',
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 16,
    fontWeightBold: 700,
    letterSpacing: '2px',
    title1: {
        fontSize: '4rem',
    },
    title2: {
        fontSize: '2rem',
        letterSpacing: '2px',
    },
    subtitle1: {
        fontSize: '1rem',
        fontFamily: [
            'Roboto Thin',
            'sans-serif',
        ].join(','),
        fontWeightThin: '200',
        letterSpacingSub: '2px'
    }
  },
});

export default theme;